import { useQuery } from '@tanstack/react-query';
import { getOplatiDeposit } from '@/widgets/account-operations/api/requests';
import type { OplatiDepositResponse } from '@/shared/types';
import { CACHE_TIME_10_MINUTES, CACHE_TIME_5_MINUTES } from '@/shared/config';

export function useOplatiDeposit() {
  const query = useQuery<OplatiDepositResponse, Error>({
    queryKey: ['oplatiDeposit'],
    queryFn: getOplatiDeposit,
    staleTime: CACHE_TIME_5_MINUTES,
    gcTime: CACHE_TIME_10_MINUTES,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    status: query.status,
    refetch: query.refetch,
  };
}
